class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

//商品番号検索
customElements.define('main-search', MainSearch);

document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/search')) return;

  const params = new URLSearchParams(window.location.search);
  const q = params.get('q');

  if (!q) return;

  const keyword = q.trim().toLowerCase();

  const isProductCode =
    /^[a-z]{2}\d{2,}/.test(keyword);

  if (isProductCode) {
    document.body.classList.add('is-product-code-search');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('is-product-code-search')) return;

  const moveProductsNav = () => {
    const productsNav = document.getElementById('productsNav');
    const boostSide = document.getElementById('boost-sd-filter-tree-column');

    if (!productsNav || !boostSide) return false;
    if (boostSide.contains(productsNav)) return true;

    boostSide.innerHTML = '';
    boostSide.appendChild(productsNav);
    boostSide.style.display = '';

    return true;
  };

  const observer = new MutationObserver(() => {
    if (moveProductsNav()) {
      observer.disconnect();
    }
  });

  if (!moveProductsNav()) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => observer.disconnect(), 10000);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('is-product-code-search')) return;

  const fixClearButtonPosition = () => {
    document
      .querySelectorAll('button[type="reset"].boost-sd__button--float')
      .forEach((button) => {
        button.style.setProperty('right', '5rem', 'important');
        button.style.setProperty('inset-inline-end', '5rem', 'important');
      });
  };

  fixClearButtonPosition();
  setTimeout(fixClearButtonPosition, 500);
  setTimeout(fixClearButtonPosition, 1500);
  setTimeout(fixClearButtonPosition, 3000);
});

document.addEventListener('DOMContentLoaded', () => {
  const replaceBoostIcons = () => {

    // 検索ボタン
    document.querySelectorAll('.boost-sd__search-form-submit-btn').forEach((button) => {
      if (!button.dataset.searchIconReplaced) {
        button.innerHTML = `
          <span class="svg-wrapper">
            <svg fill="none" class="icon icon-search" viewBox="0 0 18 19">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        `;
        button.dataset.searchIconReplaced = 'true';
      }
    });

    // クリアボタン
    document
      .querySelectorAll('button[type="reset"].boost-sd__button--float')
      .forEach((button) => {
        if (!button.dataset.clearIconReplaced) {
          button.innerHTML = `
            <span class="svg-wrapper">
              <svg fill="none" stroke="currentColor" class="icon icon-close" viewBox="0 0 18 18">
                <circle cx="9" cy="9" r="8.5" stroke-opacity=".2"></circle>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.83 11.83 6.172 6.17M6.229 11.885l5.544-5.77"
                ></path>
              </svg>
            </span>
          `;

          button.style.setProperty('right', '8rem', 'important');
          button.style.setProperty('inset-inline-end', '8rem', 'important');

          button.dataset.clearIconReplaced = 'true';
        }
      });
  };

  replaceBoostIcons();

  const observer = new MutationObserver(() => {
    replaceBoostIcons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => observer.disconnect(), 10000);
});